import styled from 'styled-components';

export const HeadlineRow = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
`;

export const MemoTextContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
`;

export const MemoTextWrapper = styled.div`
	padding: 6px;
`;

export const ContentMemoText = styled.div`
	width: calc(100%);
	overflow: hidden;
	padding: 16px;

	-webkit-user-select: text;
	-moz-user-select: text;
	-ms-user-select: text;
	user-select: text;

	border-radius: 16px;
	background-color: ${({ theme }) => theme['warmgray-50']};
`;
